import { action, observable } from 'mobx';
import { CALENDAR_SHIPPING_FEE_URL } from '../constants/apiUrls/apiUrls';
import callApi from '../utils/callApi';


class CalendarCheckoutStore {
  @observable selectedProduct = null;
  @observable shippingDetails = null; 
  @observable finalProduct = null; 
  @observable shippingCostsLoading = false;
  @observable error = null;
  // Selected product at step 1 
  @action setProduct = prod =>{
    this.selectedProduct = prod;
   
  }

  // Shipping details in the form 
  @action setShippingDetails = details => {
    this.shippingDetails = details;
  }

  // Get the product along with shipping costs
  @action getShippingFee = (zipCode, country) => {
    this.finalProduct = null; 
    const calendarType = this.selectedProduct.product.details.calendarType;
    const FEE_URL = CALENDAR_SHIPPING_FEE_URL.replace('{calendarType}', encodeURIComponent(calendarType))
    .replace('{cc}', encodeURIComponent(country))
    .replace('{zc}', encodeURIComponent(zipCode));

    this.shippingCostsLoading = true;
    callApi(FEE_URL , 'GET', {},{},{},false)
      .then(shippingResponse => {
      console.log('shippingResponse' ,shippingResponse)
      this.shippingCostsLoading = false;
      if(shippingResponse.data.status === 'SUCCESS'){
        this.finalProduct = {
          product: shippingResponse.data.products[0],
          paymentMethod: this.selectedProduct.paymentMethod
        }
        this.error = null;
      } else {
        this.error = shippingResponse.data.reason;
        console.error('Culd not get the appropriate respose');
      }
    }).catch(err => {
      this.shippingCostsLoading = false;
      console.error('coul not get shipping costs', err)
    });
  }
}

export default new CalendarCheckoutStore();